(function () {
  var desktopMedia = window.matchMedia("(min-width: 768px)");

  function initializeGallery(section) {
    if (!section || section.dataset.pdpGalleryZoomReady === "true") return;

    var modal = section.querySelector("[data-pdp-zoom-modal]");
    if (!modal) return;

    section.dataset.pdpGalleryZoomReady = "true";

    var slides = Array.prototype.slice.call(modal.querySelectorAll("[data-pdp-zoom-slide]"));
    var images = Array.prototype.slice.call(modal.querySelectorAll("[data-pdp-zoom-image]"));
    var previousButton = modal.querySelector("[data-pdp-zoom-prev]");
    var nextButton = modal.querySelector("[data-pdp-zoom-next]");
    var closeButton = modal.querySelector("[data-pdp-zoom-close]");
    var count = modal.querySelector("[data-pdp-zoom-count]");
    var status = modal.querySelector("[data-pdp-zoom-status]");
    var stage = modal.querySelector("[data-pdp-zoom-stage]");
    var activeIndex = 0;
    var returnFocus = null;
    var touchStartX = 0;
    var touchStartY = 0;
    var didSwipe = false;

    function normalizeIndex(index) {
      if (!slides.length) return 0;
      return (index + slides.length) % slides.length;
    }

    function loadImage(index) {
      var image = images[normalizeIndex(index)];
      if (image && !image.getAttribute("src")) {
        image.setAttribute("src", image.dataset.src);
      }
    }

    function resetZoom() {
      images.forEach(function (image) {
        image.classList.remove("is-zoomed");
        image.style.transformOrigin = "50% 50%";
      });
    }

    function showSlide(index, announce) {
      activeIndex = normalizeIndex(index);
      resetZoom();
      loadImage(activeIndex);
      loadImage(activeIndex - 1);
      loadImage(activeIndex + 1);

      slides.forEach(function (slide, slideIndex) {
        var isActive = slideIndex === activeIndex;
        slide.hidden = !isActive;
        slide.setAttribute("aria-hidden", String(!isActive));
      });

      count.textContent = activeIndex + 1 + " / " + slides.length;
      previousButton.disabled = slides.length < 2;
      nextButton.disabled = slides.length < 2;

      if (announce) {
        status.textContent = "Фото " + (activeIndex + 1) + " з " + slides.length;
      }
    }

    function openGallery(index, trigger) {
      returnFocus = trigger || document.activeElement;
      modal.hidden = false;
      modal.setAttribute("aria-hidden", "false");
      document.body.classList.add("pdp-gallery-zoom-open");
      showSlide(index, false);
      closeButton.focus();
    }

    function closeGallery() {
      if (modal.hidden) return;
      resetZoom();
      modal.hidden = true;
      modal.setAttribute("aria-hidden", "true");
      document.body.classList.remove("pdp-gallery-zoom-open");
      if (returnFocus && typeof returnFocus.focus === "function") {
        returnFocus.focus();
      }
    }

    function move(direction) {
      if (slides.length < 2) return;
      showSlide(activeIndex + direction, true);
    }

    section.addEventListener("click", function (event) {
      var buttonTrigger = event.target.closest("[data-pdp-zoom-button]");
      var imageTrigger = event.target.closest("[data-pdp-zoom-open]");
      var trigger = buttonTrigger || imageTrigger;

      if (!trigger || (!buttonTrigger && !desktopMedia.matches)) return;

      event.preventDefault();
      openGallery(parseInt(trigger.dataset.pdpZoomIndex, 10) || 0, trigger);
    });

    previousButton.addEventListener("click", function () { move(-1); });
    nextButton.addEventListener("click", function () { move(1); });
    closeButton.addEventListener("click", closeGallery);

    images.forEach(function (image) {
      image.addEventListener("click", function (event) {
        if (didSwipe) return;

        if (!image.classList.contains("is-zoomed")) {
          var bounds = image.getBoundingClientRect();
          var x = ((event.clientX - bounds.left) / bounds.width) * 100;
          var y = ((event.clientY - bounds.top) / bounds.height) * 100;
          image.style.transformOrigin = x + "% " + y + "%";
        } else {
          image.style.transformOrigin = "50% 50%";
        }

        image.classList.toggle("is-zoomed");
      });
    });

    stage.addEventListener("touchstart", function (event) {
      if (event.touches.length !== 1) return;
      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
      didSwipe = false;
    }, { passive: true });

    stage.addEventListener("touchend", function (event) {
      if (!event.changedTouches.length || images[activeIndex].classList.contains("is-zoomed")) return;

      var deltaX = event.changedTouches[0].clientX - touchStartX;
      var deltaY = event.changedTouches[0].clientY - touchStartY;
      if (Math.abs(deltaX) > 50 && Math.abs(deltaX) > Math.abs(deltaY)) {
        didSwipe = true;
        move(deltaX < 0 ? 1 : -1);
        window.setTimeout(function () { didSwipe = false; }, 0);
      }
    }, { passive: true });

    modal.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        event.preventDefault();
        closeGallery();
      } else if (event.key === "ArrowLeft") {
        event.preventDefault();
        move(-1);
      } else if (event.key === "ArrowRight") {
        event.preventDefault();
        move(1);
      } else if (event.key === "Tab") {
        var controls = [previousButton, closeButton, nextButton].filter(function (control) {
          return !control.disabled;
        });
        var firstControl = controls[0];
        var lastControl = controls[controls.length - 1];

        if (event.shiftKey && document.activeElement === firstControl) {
          event.preventDefault();
          lastControl.focus();
        } else if (!event.shiftKey && document.activeElement === lastControl) {
          event.preventDefault();
          firstControl.focus();
        }
      }
    });

    showSlide(0, false);
  }

  function initializeAll(root) {
    var sections = [];
    if (root.matches && root.matches("[data-section-type='product-template']")) sections.push(root);
    sections = sections.concat(Array.prototype.slice.call(root.querySelectorAll("[data-section-type='product-template']")));
    sections.forEach(initializeGallery);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initializeAll(document); });
  } else {
    initializeAll(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initializeAll(event.target);
  });
})();
